export default "__VITE_ASSET__CSAK_NqD__"